import { useRef } from "react";
import emailjs from "emailjs-com";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  Button,
  Select,
  Textarea,
  Box,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import { useAuth } from "hooks/useAuth";

const Suporte = () => {
  const { user } = useAuth();
  const form = useRef<any>();

  const formik = useFormik({
    initialValues: {
      tipo: "",
      categoria: "",
      urgencia: "",
      titulo: "",
      descricao: "",
    },
    validationSchema: Yup.object({
      tipo: Yup.string().required("Preencha o tipo"),
      categoria: Yup.string().required("Preencha a categoria"),
      urgencia: Yup.string().required("Preencha o tipo de urgência"),
      titulo: Yup.string().required("Preencha o título"),
      descricao: Yup.string().required("Preencha a descrição"),
    }),
    onSubmit: async (values, actions) => {
      const operadora = user?.operadora && user?.operadora.nm_operadora;

      const entidade = user?.entidade && user?.entidade.nm_entidade;

      const templateParams = {
        nome: user?.nome,
        email: user?.email,
        operadoraPessoaJuridica: operadora
          ? `Operadora - ${operadora}`
          : entidade && `Pessoa Jurídica - ${entidade}`,
        tipo: values.tipo,
        categoria: values.categoria,
        urgencia: values.urgencia,
        titulo: values.titulo,
        descricao: values.descricao,
      };

      actions.setSubmitting(true);

      try {
        await emailjs
          .send(
            // @ts-ignore
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID_CHAMADO,
            templateParams,
            process.env.REACT_APP_USER_ID,
          )
          .then((res) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Chamado enviado com sucesso",
              showConfirmButton: false,
              timer: 3000,
            }).then((res) => {
              actions.setSubmitting(false);
              if (res.isDismissed) {
                // setCloseModal(onClose);
              }
              formik.resetForm();
            });
          });
      } catch (e) {
        console.log(e);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Chamado não enviado. Tente novamente!",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
  });

  return (
    <Box
      maxWidth="400px"
      width="100%"
      margin="30px"
      height="max-content"
      backgroundColor="#fff"
      padding="15px"
      boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
    >
      <form
        style={{ width: "100%", height: "100%" }}
        ref={form}
        onReset={formik.handleReset}
        onSubmit={formik.handleSubmit}
      >
        <Grid gap={6}>
          <FormControl
            isInvalid={formik.values.tipo.length < 1 && formik.touched.tipo}
          >
            <h3
              style={{
                textAlign: "center",
                fontSize: "19px",
                fontWeight: "bold",
              }}
            >
              Abrir Chamado
            </h3>
            <p
              style={{
                textAlign: "center",
                fontSize: "17px",
                margin: "8px 0 15px",
              }}
            >
              Registre aqui o seu chamado, em breve entraremos em contato com a
              resolução.
            </p>
            <FormLabel htmlFor="tipo">
              Tipo <span style={{ color: "#E53E3E" }}>*</span>
            </FormLabel>
            <Select
              placeholder="Selecione o tipo"
              id="tipo"
              name="tipo"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.tipo}
            >
              <option value="Requisição">Requisição</option>
              <option value="Incidente">Incidente</option>
            </Select>
            {formik.touched.tipo && formik.errors.tipo ? (
              <FormErrorMessage>{formik.errors.tipo}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl
            isInvalid={
              formik.values.categoria.length < 1 && formik.touched.categoria
            }
          >
            <FormLabel htmlFor="categoria">
              Categoria <span style={{ color: "#E53E3E" }}>*</span>
            </FormLabel>
            <Select
              placeholder="Selecione a categora"
              id="categoria"
              name="categoria"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.categoria}
            >
              <option value="Financeiro/Contabilidade">
                Financeiro/Contabilidade
              </option>
              <option value="Jurídico">Jurídico</option>
              <option value="Operações">Operações</option>
              <option value="Tecnologia">Tecnologia</option>
            </Select>
            {formik.touched.categoria && formik.errors.categoria ? (
              <FormErrorMessage>{formik.errors.categoria}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl
            isInvalid={
              formik.values.urgencia.length < 1 && formik.touched.urgencia
            }
          >
            <FormLabel htmlFor="urgencia">
              Urgência <span style={{ color: "#E53E3E" }}>*</span>
            </FormLabel>
            <Select
              placeholder="Selecione o tipo da urgência"
              id="urgencia"
              name="urgencia"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.urgencia}
            >
              <option value="Baixa">Baixa</option>
              <option value="Média">Média</option>
              <option value="Alta">Alta</option>
              <option value="Muito alta">Muito alta</option>
            </Select>
            {formik.touched.urgencia && formik.errors.urgencia ? (
              <FormErrorMessage>{formik.errors.urgencia}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl
            isInvalid={formik.values.titulo.length < 1 && formik.touched.titulo}
          >
            <FormLabel htmlFor="titulo">
              Título <span style={{ color: "#E53E3E" }}>*</span>
            </FormLabel>
            <Textarea
              id="titulo"
              name="titulo"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.titulo}
            />
            {formik.touched.titulo && formik.errors.titulo ? (
              <FormErrorMessage>{formik.errors.titulo}</FormErrorMessage>
            ) : null}
          </FormControl>

          <FormControl
            isInvalid={
              formik.values.descricao.length < 1 && formik.touched.descricao
            }
          >
            <FormLabel htmlFor="descricao">
              Descrição <span style={{ color: "#E53E3E" }}>*</span>
            </FormLabel>
            <Textarea
              id="descricao"
              name="descricao"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.descricao}
            />
            {formik.touched.descricao && formik.errors.descricao ? (
              <FormErrorMessage>{formik.errors.descricao}</FormErrorMessage>
            ) : null}
          </FormControl>
          <Button
            isLoading={formik.isSubmitting}
            type="submit"
            colorScheme="blue"
          >
            Enviar
          </Button>
        </Grid>
      </form>
    </Box>
  );
};

export default Suporte;
